/* eslint-disable sort-keys */
export const ratingWrapper = {
    display: 'flex',
    margin: '10px 0',
    variants: {
        align: {
            right: {justifyContent: 'flex-end'},
            center: {justifyContent: 'center'},
        },
    },
}

export const ratingItem = {}

export const emojiButton = {
    background: 'none',
    border: 'none',
    height: '100%',
    width: '100%',
}

export const npsContent = {
    justifyContent: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '5px',
}

export const npsButton = {
    backgroundColor: '$questionnaireNpsBackground',
    border: '1px solid $questionnaireNpsBorder',
    borderRadius: '6px',
    boxSizing: 'border-box',
    height: '40px',
    width: '50px',
    variants: {
        selected: {
            true: {
                backgroundColor: '$questionnaireNpsSelectedBackground',
                borderColor: '$questionnaireNpsSelectedBackground',
                color: '$questionnaireNpsSelected',
            },
        },
        newLine: {true: {flexBasis: '100%'}},
    },
}

export const npsLineBreak = {
    flexBasis: '100%',
    height: 0,
}

export const npsLabel = {
    color: '$questionnaireNpsLabel',
    fontSize: '14px',
    margin: '5px 0',
    variants: {type: {bottom: {textAlign: 'right'}}},
}

export const customIconWrapper = {
    'height': '$$height',
    'width': '$$width',
    ' > svg, > img': {
        width: '100%',
        height: '100%',
    },
}


